<template>
  <div class="manufacturer-profile-wrapper">
    <h2>Manufacturer Profile</h2>
    <hr>
    <div class="manufacturer-profile">
      <div class="manufacturer-profile__card card card-1 shadow-sm">
        <div class="card-header">
          <div class="d-flex justify-content-between">
            <h5 class="card-title">General Information</h5>
            <div :class="['dealer-status', dealerStatusClass ]">{{ dealerStatusText }}</div>
          </div>
          <hr>
        </div>
        <div class="card-body">
          <div class="container p-0 m-0">
            <div class="row mb-2">
              <div class="col">
                <BasicTextInput placeholder="Enter Manufacturer Name" label="Manufacturer Name" v-model="manufacturer.name"/>
              </div>
              <div class="col">
                <BasicTextInput placeholder="Enter Manufacturer Code" label="Manufacturer Code" v-model="manufacturer.code" :disabled="true"/>
              </div>
            </div>
            <div class="row mb-2">
              <div class="col">
                <DatePicker label="Effective From" v-model="manufacturer.effectiveFromDate" />
              </div>
              <div class="col">
                <DatePicker label="Effective To"   v-model="manufacturer.effectiveToDate"   />
              </div>
            </div>
            <div class="row mb-2">
              <div class="col">
                <BasicTextInput placeholder="Enter Website" label="Website"       v-model="manufacturer.website" />
              </div>
            </div>
            <div class="row mb-2">
              <div class="col-8">
                <BasicTextInput placeholder="Enter Street" label="Address Line 1" v-model="manufacturer.address1" />
              </div>
              <div class="col-4">
                <BasicTextInput placeholder="Enter Unit"   label="Address Line 2" v-model="manufacturer.address2" />
              </div>
            </div>
            <div class="row mb-2">
              <div class="col">
                <BasicTextInput placeholder="Enter City" label="City"             v-model="manufacturer.city"     />
              </div>
              <div class="col">
                <StateSelect    label="State" v-model="manufacturer.state"/>
              </div>
              <div class="col">
                <ZipCodeInput placeholder="Enter Zip" label="Zip" v-model="manufacturer.zip" />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="manufacturer-profile__card card card-2 shadow-sm">
        <div class="card-header">
          <h5 class="card-title">Certified Dealers</h5>
          <hr>
        </div>
        <div class="card-body">
          <div class="card dealer-list-display-card p-0 m-0">
            <div v-for="(dealer,index) in dealers" :key="index" class="row">
              <div class="col dealer-list-item">
                <div class="custom-control custom-checkbox">
                  <input type="checkbox" class="custom-control-input"
                         :id="`dealer-id-${dealer.Id}`"
                         v-model="manufacturerAuthedDealers"
                         :value="dealer.Id">
                  <label class="custom-control-label" :for="`dealer-id-${dealer.Id}`"><b>{{ getDealerName(dealer.Id) }}</b></label>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="manufacturer-profile__card card card-3 shadow-sm">
        <div class="card-header">
          <div class="d-flex justify-content-between">
            <h5 class="card-title">Phone Numbers</h5>
            <div class="btn btn-primary btn-sm" @click="addPhoneNumber">Add Phone Number</div>
          </div>
          <hr>
        </div>
        <div class="card-body">
          <div class="container p-0 m-0">
            <div class="row" v-for="(numberObj, index) in phoneNumbers">
              <SelectInput       class="col-4" v-model.number="numberObj.NumberType"  :list="phoneNumTypeList"/>
              <PhoneNumberInput  class="col-6" v-model="numberObj.Number" />
              <div class="col-2 d-flex align-items-end">
                <div class="btn btn-danger" @click="removePhoneNumber(index)">&times;</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="manufacturer-profile__card card card-4 shadow-sm">
        <div class="card-header">
          <h5 class="card-title">Smart Catalog</h5>
          <hr>
        </div>
        <div class="card-body">
          <div class="container p-0 m-0">
            <div class="d-flex justify-content-between align-items-center">
                <FileInput ref="smartCatFileUpload" v-on:fileSelected="stageFile"/>
            </div>
            <div class="btn btn-secondary mr-2" v-if="tempFiles.length > 0" @click="clearFileUpload">Clear</div>
            <div class="btn btn-primary"        v-if="tempFiles.length > 0" @click="uploadSmartCatalogFile">Upload</div>
          </div>
        </div>
      </div>

    </div>



    <div class="btn-wrapper">
      <button type="button" class="btn btn-secondary" @click="routeToManfSearch">Cancel</button>
      <button type="button" class="btn btn-primary"   @click="saveManufacturer">Save</button>
    </div>
    
  </div>
  
</template>

<script>

import Checkbox                           from '../../../components/inputComponents/Checkbox.vue';

import moment                             from 'moment';

import { ManufacturerService, DealerService }              from '@/services'

import {
  uuid,
  getKeyByValue,
  phoneNumTypeEnum }                      from '@/modules/helpers.js';

export default {
  name: 'ManufacturerEdit',

  data(){
    return {
      phoneNumTypeEnum: phoneNumTypeEnum,
      manufacturer: {},
      phoneNumbers: [],
      dealers: [],
      manufacturerAuthedDealers: [],
      tempFiles: [],
    }
  },
  computed: {
    phoneNumTypeList(){
        return Object.keys(this.phoneNumTypeEnum).map(en => {
          return {
            text: en, value: this.phoneNumTypeEnum[en]
          }
        });
    },
    isActiveDealer(){
      let currentDay = moment();
      let start      = moment(this.manufacturer.effectiveFromDate);
      let end        = moment(this.manufacturer.effectiveToDate  );
      return currentDay.isBetween(start, end, 'days', '[]') // all inclusive
    },
    dealerStatusText(){
      return this.isActiveDealer ? 'active' : 'inactive';
    },
    dealerStatusClass(){
      return this.isActiveDealer ? 'dealer-status__active' : 'dealer-status__inactive';
    }
  },
  methods: {
    uploadSmartCatalogFile(){
      if (this.tempFiles.length < 1){
        this.$store.dispatch('ADD_NOTIFICATION', { text: 'No File Selected', type: 'error' });
        return;
      }
      ManufacturerService.uploadCatalog(this.manufacturer.id, this.tempFiles[0]).then(res => {
        this.clearFileUpload();
        this.$store.dispatch('ADD_NOTIFICATION', { text:'Smart Catalog Uploaded Successfully', type: 'success' });
      }).catch(err => {
        this.$store.dispatch('ADD_NOTIFICATION', { text: err.response, type: 'error' });
      })
    },
    clearFileUpload(){
       this.tempFiles = [];
       this.$refs.smartCatFileUpload.clear();
    },
    routeToManfSearch(){
       this.$router.push({ name: 'ManufacturerSearch' });
    },
    removePhoneNumber(index){
      this.phoneNumbers.splice(index,1);
    },
    addPhoneNumber(){
      this.phoneNumbers.push({
        NumberType : 1,
        Number     : ""
      })
    },
    getDealerName(dealerId){
      return this.dealers.filter(d => d.Id === dealerId)[0]['DisplayName'];
    },
    getManufacturersAndDealers() {
      let promises = [];
      promises.push(DealerService.all());
      if(this.$route.name === 'SmartCatalogManufacturerEdit'){
        promises.push(ManufacturerService.getSmartCatalogManufacturer(this.$route.params.id));
      } else{
        promises.push(ManufacturerService.get(this.$route.params.id));
      }
      

      Promise.all(promises).then(res => {
        this.dealers                   = res[0];
        this.manufacturer              = this.formatManufacturer(res[1]);
        this.phoneNumbers              = this.formatPhoneNumbers(res[1]);
        this.manufacturerAuthedDealers = res[1].AuthorizedDealerIds;
      }).catch(err => {
        console.error(err);
      })
    },
    formatManufacturer(manfacturerResponse){
      let formattedManf = {};
      formattedManf.id   = manfacturerResponse.Id;
      formattedManf.name = manfacturerResponse.CompanyName;
      formattedManf.code = manfacturerResponse.Code;
      formattedManf.effectiveFromDate = moment(manfacturerResponse.EffectiveFrom).format('MM/DD/YYYY');
      formattedManf.effectiveToDate   = moment(manfacturerResponse.EffectiveTo  ).format('MM/DD/YYYY');
      formattedManf.website           = manfacturerResponse.Website;
      formattedManf.address1          = manfacturerResponse.Address.Line1;
      formattedManf.address2          = manfacturerResponse.Address.Line2;
      formattedManf.city              = manfacturerResponse.Address.City;
      formattedManf.state             = manfacturerResponse.Address.StateId;
      formattedManf.zip               = manfacturerResponse.Address.ZipCode;
      return formattedManf;
    },
    formatPhoneNumbers(manufacturerResponse){
      return manufacturerResponse.PhoneNumbers.map(numObj => {
        return {
          NumberType: numObj.NumberType,
          Number    : numObj.Number,
        }
      })
    },
    stageFile(f){
      this.tempFiles.push(f[0]);
    },
    setManufacturerData(){
      return { 
        id:            this.$route.params.id, // TODO: The ID returned in the GET is always 0
        CompanyName:   this.manufacturer.name,
        Code:   this.manufacturer.code,
        EffectiveFrom: this.manufacturer.effectiveFromDate,
        EffectiveTo:   this.manufacturer.effectiveToDate,
        Website:       this.manufacturer.website,
        Address: {
          Line1:   this.manufacturer.address1,
          Line2:   this.manufacturer.address2,
          City:    this.manufacturer.city,
          StateId: this.manufacturer.state,
          ZipCode: this.manufacturer.zip,
        },
        AuthorizedDealerIds: this.manufacturerAuthedDealers,
        PhoneNumbers: this.phoneNumbers,
      };
    },
    defaultManufacturerUpdate(data){
      ManufacturerService.update(data).then(res => {
        this.$store.dispatch('ADD_NOTIFICATION', { text: 'Manufacturer Saved', type: 'success' });
      }).catch(err => {
        this.$store.dispatch('ADD_NOTIFICATION', { text: err.response.data.Message, type: 'error' });
      })
    },
    smartCatalogManufacturerUpdate(data){
      ManufacturerService.updateSmartCatalogManufacturer(data).then(res => {
        this.$store.dispatch('ADD_NOTIFICATION', { text: 'Manufacturer Saved', type: 'success' });
      }).catch(err => {
        this.$store.dispatch('ADD_NOTIFICATION', { text: err.response.data.Message, type: 'error' });
      })
    },
    saveManufacturer(){
      let data = this.setManufacturerData()
      if(this.$route.name === 'SmartCatalogManufacturerEdit'){
        this.smartCatalogManufacturerUpdate(data);
      }else{
        this.defaultManufacturerUpdate(data);
      }
    }
  },
  mounted(){
     this.getManufacturersAndDealers();
  }

}
</script>

<style scoped lang="scss">
  .manufacturer-profile-wrapper{
    min-height: 100%;
    // max-width: 1800px;
  
    .manufacturer-profile{
      .dealer-status {
        font-size: 1rem;
        text-transform: uppercase;
        &__active   { color: $success; }
        &__inactive { color: $error;   }
      }

      .card-1 {
        grid-area: card-1
      }
      .card-2 {
        grid-area: card-2
      }
      height: 90%;
      display: grid;
      grid-template-columns: 60% 40%;
      grid-template-rows: auto;
      grid-template-areas: "card-1 card-2";
      &__card{
        margin: 10px;
      }
    }
    .right-justify-col {
      display: flex;
      justify-content: flex-end;
    }
    .dealer-list-display-card {
      background-color: white;
      height: 100%;
      max-height: 400px;
      overflow: scroll;
      i {
        font-size: 12px;
      }
      .dealer-list-item {
        display: flex;
        justify-content: flex-start;
        align-items: center;
        margin-left: 10px;
        .spacing-left {
          margin-left: 10px;
        }
      }
    }

    .btn-wrapper{
      width: 100%;
      padding: 10px;
      display: flex;
      justify-content: flex-end;
      align-items: center;
      .btn {
        margin: 5px;
      }
    }
  }
  
</style>
